


























import {Vue, Component, Prop} from 'vue-property-decorator';
import Change, {ElementChange, InstanceId, ListChange} from "@/components/history/dto/Change";
import moment from "moment/moment";

@Component({})
export default class ListChangeView extends Vue {
	@Prop()
	private change!: ListChange

	@Prop()
	private label!: string

	@Prop()
	private schema!: any

	@Prop({required: false})
	private action?: (change: InstanceId) => void

	private invokeAction(value: any) {
		console.log((value))
		console.log(this.isItemReferenceChangeObject(value))
		if (this.isReferenceChangeObject(value) && this.action) {
			this.action(new InstanceId(value.value));
		} else if (this.isItemReferenceChangeObject(value) && this.action) {
			this.action(new InstanceId(value));
		}
	}

	formatValue(value: ElementChange, property: string | null = null): string {
		if (value === null || value === undefined) {
			return '—';
		}

		if (this.isReferenceChangeObject(value)) {
			return this.formatReferenceChangeObject(value, property);
		}


		if (typeof value === 'object') {
			return JSON.stringify(value, null, 2);
		}
		return moment(String(value)).isValid() ? moment(String(value)).format('M.DD.YYYY') : String(value);
	}

	private isReferenceChangeObject(value: ElementChange): boolean {
		return value &&
			typeof value === 'object' &&
			value.value &&
			value.value.props
	}

	private isItemReferenceChangeObject(value: any): boolean {
		return value &&
			typeof value === 'object' &&
			value.props
	}

	private formatReferenceChangeObject(value: ElementChange, property: string | null = null): string {
		const props = value.value.props;
		if (!props || typeof props !== 'object') {
			return JSON.stringify(value, null, 2);
		}

		const formattedValues: string[] = [];

		Object.keys(props).forEach(key => {
			const propValue = props[key];
			if (propValue !== null && propValue !== undefined) {
				const label = this.schema[property!][key];
				formattedValues.push(`${label}: ${moment(propValue).isValid() ? moment(propValue).format('M.DD.YYYY') : propValue}`);
			}
		});

		if (formattedValues.length == 0) {
			if (value.value.cdoId) {
				formattedValues.push(`ID: ${value.value.cdoId}`);
			}
			if (value.value.typeName) {
				const typeName = value.value.typeName.split('.').pop(); // Берем только имя класса
				formattedValues.push(`Type: ${typeName}`);
			}
		}

		return formattedValues.join('\n');
	}

	private formatElChange(value: any, property: string | null = null) {
		if (value === null || value === undefined) {
			return '—';
		}
		const props = value.props;
		if (!props || typeof props !== 'object') {
			return JSON.stringify(value, null, 2);
		}

		const formattedValues: string[] = [];

		Object.keys(props).forEach(key => {
			const propValue = props[key];
			if (propValue !== null && propValue !== undefined) {
				const label = this.schema[property!][key];
				formattedValues.push(`${label}: ${moment(propValue).isValid() ? moment(propValue).format('M.DD.YYYY') : propValue}`);
			}
		});

		if (formattedValues.length == 0) {
			if (value.cdoId) {
				formattedValues.push(`ID: ${value.cdoId}`);
			}
			if (value.typeName) {
				const typeName = value.typeName.split('.').pop(); // Берем только имя класса
				formattedValues.push(`Type: ${typeName}`);
			}
		}

		return formattedValues.join('\n');
	}

	resolveOperationClass(elChange: ElementChange): string {
		if (elChange.elementChangeType == 'ValueRemoved') {
			return "el_change--delete"
		} else if (elChange.elementChangeType == 'ValueAdded') {
			return "el_change--add"
		} else {
			return "el_change--change"
		}
	}
}
